import React, { Component } from "react";
import { connect } from "react-redux";
import DrawDetail from "../Modal/DrawDetail";
import FreezeDetail from "../Modal/FreezeDetail";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import LoadingOverlay from "react-loading-overlay";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import {
  getMembersInfo,
  selectMembersInfo,
  selectMemberInfo,
  getDrawDetail,
  getFreezeDetail,
  getDocumentFile,
  selectDocumentFile,
  downloadCdnFile,
  downloadReportFile,
} from "../../../state/ducks/member/index";
import {
  fileUploadService,
  sendDocumentsForReviewService,
  getGuarantorsService,
  addGuarantorService,
  deleteGuarantorService
} from "../../../services/member.service"

class Expenses extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      cekilisTarihi: null,
      uye: "ÜYELİK BİLGİLERİM",
      currency: "₺",
      selectedmobilDokumanTurId: null,
      isShowLoading: false,
      guarantors: [],
      showAddGuarantorModal: false,
      showDeleteGuarantorModal: false,
      selectedGuarantorId: null,
      guarantorForm: {
        adi: "",
        soyadi: "",
        vatandaslikNo: "",
        gsm: "",
        dogumTarihi: ""
      }
    };
  }


  // Dosya seçilince çalışır
  handleFileChange = async (event) => {
    const file = event.target.files[0];
    const { selectedmobilDokumanTurId } = this.state;

    if (!file || !selectedmobilDokumanTurId) return;

    const { match } = this.props;
    var memberId = match?.params?.id;

    const formData = new FormData();
    formData.append("File", file);
    formData.append("MobilDokumanTurId", selectedmobilDokumanTurId);
    formData.append("MemberId", memberId);

    // FormData içeriğini görmek için:
    for (let pair of formData.entries()) {
      console.log(pair[0], ":", pair[1]);
    }

    this.setState({ isShowLoading: true });
    fileUploadService(formData).then((result) => {
      this.setState({ isShowLoading: false });
      console.log(result);
      if (result.success) {
        const { match } = this.props;
        var id = match?.params?.id;
        this.props.getMembersInfo(id);
        toast.success("Dosya yüklendi");

      } else {
        toast.error("Hata" + result.message);
      }
    });

  };

  // “Yükle” tıklanınca file input'u tetikler
  handleUploadClick = (mobilDokumanTurId, e) => {
    e.preventDefault();
    this.setState({ selectedmobilDokumanTurId: mobilDokumanTurId }, () => {
      try {
        this.fileInputRef.current.click();
      } catch (error) {

      }
    });
  };

  componentDidMount() {

    const { match } = this.props;

    var id = match?.params?.id;
    this.props.getMembersInfo(id);

    let result = this.props.member.info.filter((item) => {
      return item.id.toString() === id;
    });

    if (result != null && result[0] != null) {
      this.setState({ uye: result[0] });
      this.setState({
        currency: result[0].orgTurId === 3 ? "XAU" : "₺",
      });
    }

    this.loadGuarantors();
  }

  parseApiResult = (result) => {
    if (typeof result === "string") {
      try {
        return JSON.parse(result);
      } catch (error) {
        return null;
      }
    }

    return result;
  };

  normalizePhone = (value) => {
    let digits = (value || "").replace(/\D/g, "");
    if (digits.startsWith("90")) {
      digits = digits.slice(2);
    }
    digits = digits.replace(/^0+/, "");
    return digits.substring(0, 10);
  };

  formatPhone = (value) => {
    const digits = this.normalizePhone(value);
    const first = digits.slice(0, 3);
    const second = digits.slice(3, 6);
    const third = digits.slice(6, 8);
    const fourth = digits.slice(8, 10);
    return [first, second, third, fourth].filter(Boolean).join(" ");
  };

  formatDateInput = (value) => {
    const digits = (value || "").replace(/\D/g, "").slice(0, 8);
    const day = digits.slice(0, 2);
    const month = digits.slice(2, 4);
    const year = digits.slice(4, 8);

    if (digits.length <= 2) return day;
    if (digits.length <= 4) return `${day}/${month}`;
    return `${day}/${month}/${year}`;
  };

  convertDisplayDateToIso = (value) => {
    const match = (value || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) return "";

    const [, dd, mm, yyyy] = match;
    const date = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
    if (
      Number.isNaN(date.getTime()) ||
      date.getFullYear() !== Number(yyyy) ||
      date.getMonth() + 1 !== Number(mm) ||
      date.getDate() !== Number(dd)
    ) {
      return "";
    }

    return `${yyyy}-${mm}-${dd}`;
  };

  isFutureDisplayDate = (value) => {
    const isoDate = this.convertDisplayDateToIso(value);
    if (!isoDate) return false;

    const selectedDate = new Date(`${isoDate}T00:00:00`);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selectedDate > today;
  };

  loadGuarantors = () => {
    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;

    getGuarantorsService(uyelikId).then((result) => {
      const parsedResult = this.parseApiResult(result);
      const guarantors = parsedResult?.data || [];
      this.setState({ guarantors });
    }).catch(() => {
      this.setState({ guarantors: [] });
    });
  };

  openAddGuarantorModal = () => {
    this.setState({
      showAddGuarantorModal: true,
      guarantorForm: {
        adi: "",
        soyadi: "",
        vatandaslikNo: "",
        gsm: "",
        dogumTarihi: ""
      }
    });
  };

  closeAddGuarantorModal = () => {
    this.setState({ showAddGuarantorModal: false });
  };

  closeDeleteGuarantorModal = () => {
    this.setState({
      showDeleteGuarantorModal: false,
      selectedGuarantorId: null
    });
  };

  handleGuarantorInputChange = (field, value) => {
    this.setState((prevState) => ({
      guarantorForm: {
        ...prevState.guarantorForm,
        [field]: value
      }
    }));
  };

  addGuarantor = () => {
    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;
    const { guarantorForm } = this.state;
    const adi = guarantorForm.adi?.trim();
    const soyadi = guarantorForm.soyadi?.trim();
    const vatandaslikNo  = guarantorForm.vatandaslikNo?.replace(/\D/g, "");
    const gsm = this.normalizePhone(guarantorForm.gsm);
    const dogumTarihi = this.convertDisplayDateToIso(guarantorForm.dogumTarihi);

    if (!adi || !soyadi || !vatandaslikNo || !gsm || !guarantorForm.dogumTarihi) {
      toast.error("Lütfen tüm alanları doldurun");
      return;
    }

    if (!dogumTarihi) {
      toast.error("Doğum tarihi formatı gg/aa/yyyy olmalıdır");
      return;
    }

    if (this.isFutureDisplayDate(guarantorForm.dogumTarihi)) {
      toast.error("Doğum tarihi bugünden büyük olamaz");
      return;
    }

    if (vatandaslikNo.length !== 11) {
      toast.error("TC No 11 haneli olmalıdır");
      return;
    }

    if (!gsm.startsWith("5")) {
      toast.error("Telefon numarası 5 ile başlamalı ve başında 0 olmamalıdır");
      return;
    }
    

    if (gsm.length !== 10) {
      toast.error("Telefon numarası 10 haneli olmamalıdır");
      return;
    }

    this.setState({ isShowLoading: true });

    addGuarantorService({
      kartId: 0,
      uyelikId,
      adi,
      soyadi,
      vatandaslikNo,
      gsm,
      dogumTarihi
    }).then((result) => {
      const parsedResult = this.parseApiResult(result);
      this.setState({ isShowLoading: false });

      if (parsedResult?.success) {
        this.closeAddGuarantorModal();
        this.loadGuarantors();
        
        const { match } = this.props;
        var id = match?.params?.id;
        this.props.getMembersInfo(id);
        toast.success("Kefil kaydedildi");
      } else {
        toast.error(parsedResult?.message || "Kefil kaydedilemedi");
      }
    }).catch(() => {
      this.setState({ isShowLoading: false });
      toast.error("Kefil kaydedilemedi");
    });
  };

  deleteGuarantor = (guarantorId) => {
    if (!guarantorId) {
      toast.error("Silme işlemi için kefil kimliği bulunamadı");
      return;
    }

    this.setState({
      showDeleteGuarantorModal: true,
      selectedGuarantorId: guarantorId
    });
  };

  confirmDeleteGuarantor = () => {
    const { selectedGuarantorId } = this.state;

    if (!selectedGuarantorId) {
      this.closeDeleteGuarantorModal();
      toast.error("Silme işlemi için kefil kimliği bulunamadı");
      return;
    }

    this.closeDeleteGuarantorModal();

    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;

    this.setState({ isShowLoading: true });
    deleteGuarantorService({
      kartId: 0,
      uyelikId,
      id: selectedGuarantorId
    }).then((result) => {
      const parsedResult = this.parseApiResult(result);
      this.setState({ isShowLoading: false });
      if (parsedResult?.success) {
        this.loadGuarantors();
        const { match } = this.props;
        var id = match?.params?.id;
        this.props.getMembersInfo(id);
        toast.success("Kefil sime işleminiz onaya gönderildi.");
      } else {
        toast.error(parsedResult?.message || "Kefil silinemedi");
      }
    }).catch(() => {
      this.setState({ isShowLoading: false });
      toast.error("Kefil silinemedi");
    });
  };

  sendDocumentsForReview = () => {
    this.setState({ isShowLoading: true });
    const { match } = this.props;
    var memberId = Number(match?.params?.id) ?? 0;

    // const formData = new FormData();
    // formData.append("MemberId", memberId);
    var data = {
      "cardId": 0,
      memberId
    };
    sendDocumentsForReviewService(data).then((result) => {
      this.setState({ isShowLoading: false });
      if (result.success) {
        const { match } = this.props;
        var id = match?.params?.id;
        this.props.getMembersInfo(id);
        toast.success("Dosyalar incelemeye gönderildi");

      } else {
        toast.error(result.message);
      }
    });
  }

  setDrawId = (drawId, cekilisTarihi) => {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getDrawDetail(id, drawId);
    this.setState({ cekilisTarihi: cekilisTarihi });
  };

  getFreezeDetail = (source) => {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getFreezeDetail(id, source);
  };

  getDocumentFile = (documentId, documentName) => {
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.getDocumentFile(documentId, ext, documentName);
  };

  downloadCdnFile = (id, documentName) => {
    const { match } = this.props;
    var memberId = match?.params?.id;
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.downloadCdnFile(id, memberId, ext, documentName);
  };

  downloadReportFile = (raporId, documentName) => {
    const { match } = this.props;
    var memberId = match?.params?.id;
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.downloadReportFile(memberId, raporId, ext, documentName);
  };

  getAcceptTypes = (documentTypes) => {
    const map = {
      pdf: "application/pdf",
      image: "image/*"
    };

    return documentTypes
      ?.map(type => map[type])
      .filter(Boolean)
      .join(",");
  };


  render() {
    const { members } = this.props;
    const { guarantors, guarantorForm, showAddGuarantorModal, showDeleteGuarantorModal } = this.state;
    return (
      <LoadingOverlay
        active={this.state.isShowLoading}
        spinner={<ClipLoader />}
        styles={{
          overlay: (base) => ({
            ...base,
            position: "fixed",
            zIndex: 2000,
          }),
        }}
      >

        <div className="container-fluid">
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 3  EV */}

              <div className={
                this.state.uye.orgTurId === 2 ? (
                  "row no-gutters t-kutu t-yesilCizgi"

                ) : this.state.uye.orgTurId === 3 ? (
                  "row no-gutters t-kutu t-turuncuCizgi"

                ) : this.state.uye.orgTurId === 1 ? (
                  "row no-gutters t-kutu t-mavicizgi"

                ) :
                  ("")
              }>
                <div className="col bosluk backbottom">
                  {/* içerikler */}
                  {/* Başlık */}
                  <div className="row no-gutters align-items-center">
                    <div clss="col-auto">
                      {this.state.uye.orgTurId === 2 ? (
                        <i className="t-icon-home1 icon" />
                      ) :
                        ("")
                      }
                      {this.state.uye.orgTurId === 3 ? (
                        <img
                          src="/assets/img/svg/icon_kabe.svg"
                          style={{ width: 70, height: "auto", paddingRight: 10 }}
                        />
                      ) :
                        ("")
                      }
                      {this.state.uye.orgTurId === 1 ? (
                        <i className="t-icon-truck1 icon" />
                      ) :
                        ("")
                      }
                    </div>
                    <div className="col d-flex flex-column justify-content-center">
                      <div className="baslik px-0">{this.state.uye.orgSis} {" ("}
                        <NumberFormat
                          decimalSeparator={false}
                          thousandSeparator={"."}
                          value={this.state.uye.uyeNo}
                          displayType={"text"}
                        />{")"}</div>
                      <span className="altBaslik">
                        {this.state.uye.kayitTuruId !== 10 &&
                          this.state.uye.kayitTuruId !== 11
                          ? "Planlanan "
                          : ""}
                        Teslimat Tarihi : <br />  <strong>{this.state.uye.teslimTarihi}</strong>
                      </span>
                    </div>
                    <div className="col-auto ">

                      <Link to="/Home/MemberInfo" className="t-icButonTrunucu mx-auto">
                        <i className="t-icon-arrow-left2" style={{ padding: "5px" }} />
                        {" "}
                        Geri

                      </Link>
                    </div>
                  </div>

                  <div className="col-12 t-hrUzun">
                    <hr />
                  </div>
                  {/* tablı Sistem */}
                  <nav>
                    <div
                      className="nav nav-pills nav-fill nav-justified t-tablar"
                      id="nav-tab"
                      role="tablist"
                    >
                      <a
                        className={
                          this.state.uye.kayitTuruId === 8
                            ? "nav-link"
                            : "nav-link active"
                        }
                        data-toggle="tab"
                        data-target="#odemeler"
                        hidden={this.state.uye.kayitTuruId === 8}
                      >
                        ÖDEMELER
                      </a>
                      <a
                        className={
                          this.state.uye.kayitTuruId !== 8
                            ? "nav-link"
                            : "nav-link active"
                        }
                        data-toggle="tab"
                        data-target="#iadeler"
                        hidden={this.state.uye.kayitTuruId !== 8}
                      >
                        İADELER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#masraflar"
                      >
                        MASRAFLAR
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#hareketler"

                      >
                        HAREKETLER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#taksiterteleme"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          this.state.uye.dondurulanAy === null ||
                          this.state.uye.dondurulanAy === 0
                        }
                      >
                        TAKSİT ERTELEME
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#cekilisler"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.draws === null ||
                          members?.draws?.length === 0
                        }
                      >
                        ÇEKİLİŞLER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#teslimat"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.deliveryStatements?.list === null ||
                          members?.deliveryStatements?.list.length === 0
                        }
                      >
                        TESLİMAT DOSYA
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#teslimatFinans"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.deliveryFinancialStatements?.list === null ||
                          members?.deliveryFinancialStatements?.list.length === 0
                        }
                      >
                        TESLİMAT FİNANS
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#policeler"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.documents === null ||
                          members?.documents?.length === 0
                        }
                      >
                        POLİÇELER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#customerDocuments"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.customerDocuments === null ||
                          members?.customerDocuments?.length === 0
                        }
                      >
                        DOKÜMANLAR
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#deliveryDocuments"
                        hidden={
                          members?.isShowDeliveryDocuments === false
                        }
                      >
                        DOKÜMAN YÜKLE
                      </a>
                    </div>
                  </nav>
                  <div className="tab-content p-2" id="nav-tabContent">
                    {/* Ödemeler Tablosu */}
                    <div
                      className={
                        this.state.uye.kayitTuruId === 8
                          ? "tab-pane fade table-responsive show"
                          : "tab-pane fade table-responsive show active"
                      }
                      id="odemeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Dönem</th>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">Ödenen ({this.state.currency})</th>
                            <th scope="col">Kalan ({this.state.currency})</th>

                          </tr>
                        </thead>
                        <tbody>
                          {members?.memberPayments?.list &&
                            members.memberPayments.list.map((item) => {
                              let classTaksit = "";
                              if (item.tur !== "TAKSIT" && item.kalanTutar !== 0)
                                classTaksit += "taksit_tipler";
                              if (item.tur !== "TAKSIT" && item.kalanTutar === 0)
                                classTaksit += " taksit_biten-tipler";
                              if (item.kalanTutar === 0)
                                classTaksit += " t-odendi";
                              return (
                                <tr key={item.id} className={classTaksit}>
                                  <td>
                                    {item.tur !== "TAKSIT" ? (
                                      <i className="t-icon-star-full"></i>
                                    ) : (
                                      item.donem
                                    )}
                                  </td>
                                  <td>{item.tur}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.kalanTutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" colSpan={2} />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.memberPayments?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.memberPayments?.kalanTutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* İadeler*/}
                    <div
                      className={
                        this.state.uye.kayitTuruId !== 8
                          ? "tab-pane fade table-responsive show"
                          : "tab-pane fade table-responsive show active "
                      }
                      id="iadeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">İade Edilen ({this.state.currency})</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.returns?.list &&
                            members.returns.list.map((item) => {
                              return (
                                <tr key={item.id} className="t-odendi">
                                  <td>{item.islemTipi}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.returns?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                      <p
                        className="small font-italic text-muted"
                        hidden={
                          members?.returns?.dilekceTarihi === null ||
                          members?.returns?.dilekceTarihi === ""
                        }
                      >
                        {members?.returns?.dilekceTarihi}
                      </p>
                    </div>
                    {/* Masraflar*/}
                    <div className="tab-pane fade table-responsive" id="masraflar">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">Ödenen ({this.state.currency})</th>
                            <th scope="col">Kalan ({this.state.currency})</th>

                          </tr>
                        </thead>
                        <tbody>
                          {members?.expenses?.list &&
                            members.expenses.list.map((item, index) => {
                              return (
                                <tr
                                  key={item.tur + item.vadeTarihi + "_" + index}
                                  className={
                                    item.kalanTutar === 0 ? "t-odendi" : ""
                                  }
                                >
                                  <td>{item.tur}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.kalanTutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.expenses?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.expenses?.kalanTutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* Hareketler*/}
                    <div className="tab-pane fade table-responsive" id="hareketler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">İşlem Tarihi</th>
                            <th scope="col">İşlem Tutarı ({this.state.currency})</th>
                            <th scope="col">Açıklama</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.movements &&
                            members.movements.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td>{item.islemTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>{item.aciklama}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {/*Taksit Erteleme*/}
                    <div className="tab-pane fade table-responsive" id="taksiterteleme">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Erteleme Sebebi</th>
                            <th scope="col">Ay</th>
                            <th scope="col">Detay</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.freeze?.list &&
                            members.freeze.list.map((item) => {
                              return (
                                <tr key={item.id} className="t-taksiterteleme">
                                  <td>{item.ertelenmeSebebi}</td>
                                  <td>{item.ay}</td>
                                  <td>
                                    <a
                                      href="#erteleme"
                                      onClick={() =>
                                        this.getFreezeDetail(item.kaynak)
                                      }

                                      data-toggle="modal"
                                      data-target="#ertelemeModalCenter"
                                    >
                                      Detay

                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.freeze?.toplamAy}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                      <br>
                      </br>
                      <p className="small font-italic text-muted">
                        {members?.freeze?.aciklama}
                      </p>
                      <p className="small font-italic text-muted">
                        {members?.freeze?.temsilciBilgi}
                      </p>
                    </div>
                    {/* Çekilişler*/}
                    <div className="tab-pane fade table-responsive" id="cekilisler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Çekiliş Tarihi</th>
                            <th scope="col">Çekiliş Durumu</th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody>
                          {members?.draws &&
                            members.draws.map((item) => {
                              return (
                                <tr
                                  key={item.id}
                                  className={
                                    item.cekilisYapildiMi == true && item.ciktiMi ? "t-kazandiniz" : "t-cikmadi"
                                  }
                                >
                                  <td>
                                    {new Date(
                                      item.cekilisTarihi
                                    ).toLocaleDateString()}
                                  </td>
                                  <td>
                                    {item.cekilisDurumu}
                                  </td>
                                  <td>
                                    <a
                                      href="#cekilis"
                                      hidden={item.cekilisYapildiMi == false}
                                      onClick={() =>
                                        this.setDrawId(item.id, item.cekilisTarihi)
                                      }
                                      data-toggle="modal"
                                      data-target="#cekilisModalCenter"

                                    >
                                      Detay

                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {/* Teslimat */}
                    <div className="tab-pane fade table-responsive" id="teslimat">
                      {/* Tamamlanma durumu için background divindeki width değeri ve yazının % cinsinden verilmesi gerekli*/}
                      <div className="row no-gutters">
                        <div className="col-12 py-2">
                          <div className="t-oran">
                            <div className="background"
                              style={{
                                width:
                                  members?.deliveryStatements?.tamamlanmaOrani +
                                  "%",
                              }}
                              aria-valuenow={
                                members?.deliveryStatements?.tamamlanmaOrani
                              }
                              aria-valuemin="0"
                              aria-valuemax="100" />
                            <span>
                              Tamamlanma durumu <strong className="px-2"> {members?.deliveryStatements?.tamamlanmaOrani} %{" "}</strong>

                            </span>

                          </div>


                        </div>
                        <div className="col-12 py-2">
                          <span style={{ fontSize: "initial" }}>
                            Yol haritasına ve gerekli evrak listesine ulaşmak için
                            <a

                              target="_blank"
                              href={
                                this.state.uye.orgTurId === 2
                                  ? process.env.PUBLIC_URL +
                                  "/assets/docs/evraklistesi-yolharitasi-konut 2_rgb.pdf"
                                  : process.env.PUBLIC_URL +
                                  "/assets/docs/evraklistesi-yolharitasi-otomobil 2_rgb.pdf"
                              }
                            >
                              <b> tıklayınız.</b>
                            </a>
                          </span>
                        </div>
                      </div>
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adımlar</th>
                            <th scope="col">Durum</th>
                            <th scope="col">Tamamlanma Tarihi</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.deliveryStatements?.list &&
                            members.deliveryStatements.list.map((item) => {
                              return (
                                <tr
                                  key={item.id}
                                  className={item.isDurum ? "t-tamamlandi" : "t-eksik"}
                                >
                                  <td className="text-left">{item.isTuru}</td>
                                  <td>
                                    {item.isDurum ? (
                                      <i className="t-icon-check_circle_outline"></i>
                                    ) : (
                                      <i className="far fa-times-circle text-danger"></i>
                                    )}
                                  </td>
                                  <td>{item.tamamlanmaTarihi}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>


                    {/* Teslimat Finans*/}
                    <div className="tab-pane fade" id="teslimatFinans">
                      {/* Tamamlanma durumu için background divindeki width değeri ve yazının % cinsinden verilmesi gerekli*/}
                      <div className="row no-gutters">
                        <div className="col-12 py-2">
                          <div className="t-oran">
                            <div className="background"
                              style={{
                                width:
                                  members?.deliveryFinancialStatements?.tamamlanmaOrani +
                                  "%",
                              }}
                              aria-valuenow={
                                members?.deliveryFinancialStatements?.tamamlanmaOrani
                              }
                              aria-valuemin="0"
                              aria-valuemax="100" />
                            <span>
                              Tamamlanma durumu <strong className="px-2"> {members?.deliveryFinancialStatements?.tamamlanmaOrani} %{" "}</strong>

                            </span>

                          </div>


                        </div>
                        {/* <div className="col-12 py-2">
                        <span style={{ fontSize: "initial" }}>
                          Yol haritasına ve gerekli evrak listesine ulaşmak için
                          <a

                            target="_blank"
                            href={
                              this.state.uye.orgTurId === 2
                                ? process.env.PUBLIC_URL +
                                "/assets/docs/evraklistesi-yolharitasi-konut 2_rgb.pdf"
                                : process.env.PUBLIC_URL +
                                "/assets/docs/evraklistesi-yolharitasi-otomobil 2_rgb.pdf"
                            }
                          >
                            <b> tıklayınız.</b>
                          </a>
                        </span>
                      </div> */}
                      </div>

                      {members?.deliveryFinancialStatements?.list &&
                        members.deliveryFinancialStatements.list.map((item, index) => {
                          return (
                            <div key={"base_" + index}>
                              <div className="table-responsive" style={{ backgroundColor: "#efefef", padding: "4px", fontSize: "12pt", fontWeight: "600", width: "100%" }}>Teslimat Id : {item.teslimatKesintiId}</div>
                              <table className="table table-sm t-tablo">
                                <thead>
                                  <tr>
                                    <th className="text-left" scope="col">Adımlar</th>
                                    <th scope="col" width="150">Durum</th>
                                    <th scope="col" width="150">Tamamlanma Tarihi</th>
                                  </tr>
                                </thead>
                                <tbody>

                                  {item.list.map((item2) => {
                                    return (
                                      <tr
                                        key={item2.id}
                                        className={item2.isDurum ? "t-tamamlandi" : "t-eksik"}
                                      >
                                        <td className="text-left">{item2.isTuru}</td>
                                        <td>
                                          {item2.isDurum ? (
                                            <i className="t-icon-check_circle_outline"></i>
                                          ) : (
                                            <i className="far fa-times-circle text-danger"></i>
                                          )}
                                        </td>
                                        <td>{item2.isDurum ? item2.tamamlanmaTarihi : "-"}</td>
                                      </tr>
                                    );
                                  })}

                                </tbody>
                              </table>
                            </div>
                          );
                        })

                      }

                    </div>

                    {/* Poliçeler*/}
                    <div className="tab-pane fade table-responsive" id="policeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adı</th>
                            <th scope="col">Türü</th>
                            <th scope="col">Eklenme Tarihi</th>
                            <th scope="col" >İndir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.documents &&
                            members.documents.map((item) => {
                              return (
                                <tr key={item.id} className="t-policeler">
                                  <td className="text-left">{item.dosyaAdi}</td>
                                  <td>{item.dokumanTurAdi}</td>
                                  <td>{item.tarihText}</td>
                                  <td>
                                    <a
                                      href="#indir"
                                      onClick={() => this.getDocumentFile(item.id, item.dosyaAdi)}
                                    >
                                      <i className="t-icon-folder-download"></i> İndir
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}

                        </tbody>
                      </table>
                    </div>


                    {/* customerDocuments */}
                    <div className="tab-pane fade table-responsive" id="customerDocuments">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adı</th>
                            <th scope="col">Türü</th>
                            <th scope="col">Eklenme Tarihi</th>
                            <th scope="col" >İndir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.customerDocuments &&
                            members.customerDocuments.map((item) => {
                              return (
                                <tr key={item.id} className="t-policeler">
                                  <td className="text-left">{item.dosyaAdi}</td>
                                  <td>{item.dokumanTurAdi}</td>
                                  <td>{item.tarihText}</td>
                                  <td>
                                    <a
                                      href="#indir"
                                      onClick={() => this.getDocumentFile(item.id, item.dosyaAdi)}
                                    >
                                      <i className="t-icon-folder-download"></i> İndir
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}

                        </tbody>
                      </table>
                    </div>




                    {/* deliveryDocuments */}
                    <div className="tab-pane fade table-responsive mt-2" id="deliveryDocuments">
                      <div className="t-icSssCerceve" style={{ border: `1px solid` + members?.deliveryDocument?.durumRenkKodu, backgroundColor: members?.deliveryDocument?.durumRenkKodu + '54', padding: `8px 30px` }}>
                        <div
                          className="row no-gutters"
                          data-toggle="collapse"
                          data-target={``}
                        >
                          <div className="col-12">
                            <strong style={{ color: members?.deliveryDocument?.durumRenkKodu, fontSize: `11pt` }}> DURUM</strong>
                            <br />
                          </div>
                          <div className="col" style={{ fontSize: `10pt`, color: `#585858`, textAlign: `left` }}>
                            {members?.deliveryDocument?.durumMesaj}
                          </div>
                        </div>
                      </div>

                      <div className="row no-gutters mt-4 mb-2 align-items-center">
                        <div className="col-md-3">
                          <strong style={{ fontSize: `11pt` }}>Kefil Listesi</strong>
                        </div>
                        <div className="col-md-9 d-flex justify-content-end">
                          <button className="t-icButtonYesil" type="button" onClick={this.openAddGuarantorModal}>
                            <span  style={{ fontSize: `11pt` }}>Kefil Ekle</span>
                            <i className="t-icon-plus ml-1" />
                          </button>
                        </div>
                      </div>

                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Ad Soyad</th>
                            <th scope="col">TC No</th>
                            <th scope="col">Telefon</th>
                            <th scope="col">Doğum Tarihi</th>
                            <th scope="col" className="text-right">İşlem</th>
                          </tr>
                        </thead>
                        <tbody>
                          {guarantors && guarantors.length > 0 ? guarantors.map((item, index) => (
                            <tr key={item.id || item.tckn || index}>
                              <td>{item.adSoyad}</td>
                              <td>{item.tckn}</td>
                              <td>{this.formatPhone(item.gsm)}</td>
                              <td>{item.dogumTarihi ? new Date(item.dogumTarihi).toLocaleDateString("tr-TR") : "-"}</td>
                              <td className="text-right">
                                {item.isDeleted === true ? (
                                  <span className="text-warning">Silme onayı bekliyor</span>
                                ) : (
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    type="button"
                                    onClick={() => this.deleteGuarantor(item.id)}
                                  >
                                    Sil
                                  </button>
                                )}
                              </td>
                            </tr>
                          )) : (
                            <tr>
                              <td colSpan={5}>Kefil kaydı bulunmuyor.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="row no-gutters mt-4 mb-2 align-items-center">
                      
                      <div className="col-md-3">
                          <strong style={{ fontSize: `11pt` }}>Dokümanlar</strong>
                        </div>

                      <table className="table table-sm t-tablo  mt-4">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Doküman</th>
                            <th scope="col">Durum</th>
                            <th scope="col">İşlemler</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.deliveryDocument?.dokumanlar &&
                            members?.deliveryDocument?.dokumanlar.map((item, index) => {
                              return (
                                <tr className="t-policeler" key={index}>
                                  <td className="text-left ">{item.isForced ? <span style={{ color: `red` }} title="Zorunlu"><b>*</b>&nbsp;</span> : <span>&nbsp;&nbsp;</span>} {item.mobilDokumanAdi}
                                    <a className="t-upload" hidden={item.sablonRaporId == null || item.sablonRaporId == 0} href="#sablonindir"

                                      onClick={() => this.downloadReportFile(item.sablonRaporId, "Muvafakatname.pdf")}
                                    > (Şablon İndir)</a>
                                  </td>
                                  <td style={{ color: item.musteriDokumanDurumRenkKodu }}>{item.musteriDokumanDurumText}{item.musteriDokumanDurum == 2 && (item.aciklama && item.aciklama?.trim() != "") ?
                                    <i
                                      className="fa fa-info-circle ml-1"
                                      aria-hidden="true"
                                      data-toggle="tooltip"
                                      data-placement="right"
                                      style={{ color: `#f93333` }}
                                      title={item.aciklama}
                                    ></i>
                                    : <span></span>}</td>
                                  <td>
                                    {/* Gizli input */}
                                    <input
                                      type="file"
                                      ref={this.fileInputRef}
                                      style={{ display: "none" }}
                                      accept={this.getAcceptTypes(item.documentTypes)}
                                      onChange={this.handleFileChange}
                                    />
                                    <a
                                      hidden={item.isShowUpload != true}
                                      className="t-upload p-1"
                                      href="#yukle"
                                      onClick={(e) => this.handleUploadClick(item.mobilDokumanTurId, e)}
                                    >{item.id > 0 ? "Değiştir" : "Yükle"}</a>
                                    <a
                                      hidden={item.isShowDownload != true}
                                      className="t-upload p-1"
                                      href="#indir"

                                      onClick={() => this.downloadCdnFile(item.id, item.mobilDokumanDosyaAdi)}
                                    >İndir</a>
                                  </td>
                                </tr>
                              );
                            })}

                        </tbody>
                      </table>
                      </div>
                      <div className="col-12 d-flex justify-content-center pb-3">
                        <button className="t-icButtonYesil" onClick={this.sendDocumentsForReview} type="button">
                          <span>İncelemeye Gönder</span>
                          <i className="t-icon-arrow-right2" />
                        </button>
                      </div>
                    </div>

                  </div>
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              </div>
              {/* KUTU 2 BİTTİ */}
              <DrawDetail cekilisTarihi={this.state.cekilisTarihi}></DrawDetail>
              <FreezeDetail></FreezeDetail>

              {showDeleteGuarantorModal && (
                <>
                  <div className="modal fade show" style={{ display: "block", zIndex: 1002 }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                      <div className="modal-content border-0 shadow" style={{ borderRadius: 14, overflow: "hidden" }}>
                        <div
                          className="modal-header border-0"
                          style={{ backgroundColor: "#fff7ed", color: "#7c2d12", borderBottom: "1px solid #fed7aa" }}
                        >
                          <h5 className="modal-title mb-0">Silme Onayı</h5>
                          <button type="button" className="close" onClick={this.closeDeleteGuarantorModal}>
                            <span style={{ color: "#9a3412" }}>&times;</span>
                          </button>
                        </div>
                        <div className="modal-body" style={{ backgroundColor: "#fffbeb", padding: 24 }}>
                          Kefil bilgilerini silmeyi onaylıyor musunuz?
                        </div>
                        <div className="modal-footer border-0" style={{ backgroundColor: "#fffbeb", paddingTop: 8, paddingBottom: 20 }}>
                          <button
                            type="button"
                            className="btn btn-light border px-4"
                            style={{ borderRadius: 10 }}
                            onClick={this.closeDeleteGuarantorModal}
                          >
                            Vazgeç
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger px-4"
                            style={{ borderRadius: 10 }}
                            onClick={this.confirmDeleteGuarantor}
                          >
                            Evet, Sil
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-backdrop fade show" style={{ zIndex: 1001 }}></div>
                </>
              )}

              {showAddGuarantorModal && (
                <>
                  <div className="modal fade show" style={{ display: "block", zIndex: 1000 }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                      <div className="modal-content border-0 shadow" style={{ borderRadius: 14, overflow: "hidden" }}>
                        <div
                          className="modal-header border-0"
                          style={{ backgroundColor: "#f3f6fb", color: "#2f3e52", borderBottom: "1px solid #e3e8ef" }}
                        >
                          <div>
                            <h5 className="modal-title mb-0">Kefil Ekle</h5>
                            <small style={{ color: "#6b7a90" }}>Kefil bilgilerini eksiksiz doldurunuz.</small>
                          </div>
                          <button type="button" className="close" onClick={this.closeAddGuarantorModal}>
                            <span style={{ color: "#6b7a90" }}>&times;</span>
                          </button>
                        </div>
                        <div className="modal-body" style={{ backgroundColor: "#f8fafc", padding: 24 }}>
                          <div className="form-group mb-3">
                            <label className="small text-muted mb-1">Adı</label>
                            <input
                              className="form-control border-0 shadow-sm"
                              style={{ borderRadius: 10, height: 44 }}
                              value={guarantorForm.adi}
                              placeholder="Adı"
                              onChange={(e) => this.handleGuarantorInputChange("adi", e.target.value)}
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label className="small text-muted mb-1">Soyadı</label>
                            <input
                              className="form-control border-0 shadow-sm"
                              style={{ borderRadius: 10, height: 44 }}
                              value={guarantorForm.soyadi}
                              placeholder="Soyadı"
                              onChange={(e) => this.handleGuarantorInputChange("soyadi", e.target.value)}
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label className="small text-muted mb-1">TC No</label>
                            <input
                              className="form-control border-0 shadow-sm"
                              style={{ borderRadius: 10, height: 44 }}
                              value={guarantorForm.vatandaslikNo}
                              maxLength={11}
                              placeholder="11 haneli TC No"
                              onChange={(e) => this.handleGuarantorInputChange("vatandaslikNo", e.target.value.replace(/\D/g, ""))}
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label className="small text-muted mb-1">Telefon</label>
                            <input
                              className="form-control border-0 shadow-sm"
                              style={{ borderRadius: 10, height: 44 }}
                              value={this.formatPhone(guarantorForm.gsm)}
                              maxLength={13}
                              placeholder="5XX XXX XX XX"
                              onChange={(e) => this.handleGuarantorInputChange("gsm", e.target.value)}
                            />
                          </div>
                          <div className="form-group mb-0">
                            <label className="small text-muted mb-1">Doğum Tarihi</label>
                            <input
                              type="text"
                              className="form-control border-0 shadow-sm"
                              style={{ borderRadius: 10, height: 44 }}
                              inputMode="numeric"
                              maxLength={10}
                              placeholder="gg/aa/yyyy"
                              value={guarantorForm.dogumTarihi}
                              onChange={(e) => {
                                const formattedValue = this.formatDateInput(e.target.value);
                                if (formattedValue.length === 10 && this.isFutureDisplayDate(formattedValue)) {
                                  return;
                                }
                                this.handleGuarantorInputChange("dogumTarihi", formattedValue);
                              }}
                            />
                          </div>
                        </div>
                        <div className="modal-footer border-0" style={{ backgroundColor: "#f8fafc", paddingTop: 8, paddingBottom: 20 }}>
                          <button
                            type="button"
                            className="btn btn-light border px-4"
                            style={{ borderRadius: 10 }}
                            onClick={this.closeAddGuarantorModal}
                          >
                            Vazgec
                          </button>
                          <button
                            type="button"
                            className="btn px-4"
                            style={{ borderRadius: 10, backgroundColor: "#10b981", color: "#fff" }}
                            onClick={this.addGuarantor}
                          >
                            Kaydet
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-backdrop fade show" style={{ zIndex: 999 }}></div>
                </>
              )}
            </div>
          </div>
          {/* Duyurlar Baslık*/}
          {/* duyrular Bitti*/}
          <div className="row" style={{ height: 30 }} />
        </div>

      </LoadingOverlay>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
    members: selectMembersInfo(state),
    file: selectDocumentFile(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMembersInfo: (memberId) => dispatch(getMembersInfo(memberId)),
  getDrawDetail: (memberId, drawId) =>
    dispatch(getDrawDetail(memberId, drawId)),
  getFreezeDetail: (memberId, sourceId) =>
    dispatch(getFreezeDetail(memberId, sourceId)),
  getDocumentFile: (documentId, ext, documentName) => dispatch(getDocumentFile(documentId, ext, documentName)),
  downloadCdnFile: (id, memberId, ext, documentName) => dispatch(downloadCdnFile(id, memberId, ext, documentName)),
  downloadReportFile: (uyelikId, raporId, ext, documentName) => dispatch(downloadReportFile(uyelikId, raporId, ext, documentName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Expenses);
